// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".KdSz5{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center;-ms-flex-direction:column;flex-direction:column;color:#fff;position:relative}.maqKC,._3p1-7{position:absolute;width:100%}._3p1-7{height:100%;background:rgba(35,24,21,.8)}._2fl1f{position:absolute;text-align:center}._3HRSC,._3hKDK{margin-bottom:1.5rem;padding:0 1rem}._2dsHC{display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center}@media(max-width:1023px){._2dsHC{display:none}}._2dsHC>*{margin-right:1.5rem}._2dsHC>:last-child{margin-right:0}", ""]);
// Exports
exports.locals = {
	"root": "KdSz5",
	"image": "maqKC",
	"mask": "_3p1-7",
	"wrapper": "_2fl1f",
	"description": "_3HRSC",
	"title": "_3hKDK",
	"buttonGroup": "_2dsHC"
};
module.exports = exports;
